import React from 'react';
import styles from './style.module.scss';

export default class HistoryLogItem {

    // Taken from the Minesweeper game code (Taylor DeMint)
    /**
     * @constructor
     * @param {string} message main message that describes the log
     * @param {string} color the log style to apply
     * @param {boolean} canJump true if the log can be used to jump back in time, false otherwise
     * @param {object[]} [cells] list of cells to be highlighted upon hovering over this history log
     * @param {number} cells[].row row index of cell
     * @param {number} cells[].col col index of cell
     */
    // constructor(message, style, canJump, cells = []) {
    constructor(message, style) {

        this._message = message;
        this._style = style;
        // this._numJumps = 0;
        // this._canJump = canJump;
        // this._cellHighlight = cells;
        this._details = [];
    }

    /* Plain Getters */
    // get canJump() { return this._canJump; }
    // get hasHighlight() { return this._cellHighlight.length > 0; }
    get message() { return this._message; }
    // get numJumps() { return this._numJumps; }

    /**
     * Adds the given message as a detail of the log.
     * @param {string} message detail message to add to the log
     * @param {boolean} [override] true to override default tabbing
     */
    addDetail(message, override = false) {
        if (override) {
            this._details.push(message);
        } else {
            this._details.push(`\n\t${message}`);
        }
    }

    addMessage(message) {
        this._message = message;
    }


    /**
     * Clears the details of the log.
     */
    clearDetails() {
        this._details = [];
    }

    // /**
    // * Creates an HTML div element with the history log information.
    // * @param {number} key unique key
    // * @returns {HTMLDivElement} history log jsx element
    // */
    display(key) {
        let message = this._message;
        //     let i = 0;
        console.log(this._style);
        const details = this._details.slice();
        //     let offset = 0;
        //     details.slice().forEach((detail, index) => {
        //         if (detail.includes(HistoryLogSymbols.FLAG)) {
        //             const newDetail = detail.replace(`${HistoryLogSymbols.FLAG}]`, '');
        //             details.splice(index + offset, 1, newDetail, flag(i), ']');
        //             offset += 2;
        //             i++;
        //         }
        //     });

        return (
            // <div className={HistoryLogItem._styles[this._style]}
            <div className={styles.log}
                key={key}
            // onClick={this._canJump ? () => HistoryLogItem._clickHandler(this._numJumps) : null}
            // onMouseEnter={this.hasHighlight ? () => HistoryLogItem._highlighter(this._cellHighlight) : null}
            // onMouseLeave={this.hasHighlight ? () => HistoryLogItem._clearer() : null}
            >
                {message}
                {details}
            </div>
        );
    }
}